import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import LoadingPage from "../../../components/Loading";
import { sendPushNotification } from "../../../services/pushNotifications";
import PageSelector from '../../../components/PageSelector';
import Bin from '../../../svgs/RemoveSvg';
import { fetchNotifications, deleteNotificationById } from "../../../services/notifications";

function isJSONEmpty(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}
function Page(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [isloading, setIsloading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();


    const limit = 10
    const [totalItem, setTotalItem] = useState(1)
    const totalPage = Math.ceil(totalItem / limit) || 1
    const [data, setData] = useState([])
    const page = parseInt(searchParams.get('page')) || 1
    const filterName = searchParams.get('name')
    const filterType = searchParams.get('type') || '全部'
    useEffect(() => {
        if (!props.token.isLogin) return
        const timer = setTimeout(fetchData, 500)
        const interval = setInterval(fetchData, 1000 * 30)
        return () => {
            clearTimeout(timer)
            clearInterval(interval)
        }
    }, [searchParams, props.token])
    async function fetchData() {
        const filter = { partnerId: id }//{isEarn:{$ne:true}}
        //if(filterType !== '全部') filter['status'] = filterType==='草稿'?'draft':'published'
        //if(filterName) filter['name'] = {"$regex": filterName, "$options":'i'}
        const res = await fetchNotifications(props.token?.token, filter, { limit, skip: limit * (page - 1), sort: { _id: -1 } })
        if (res.errno) return
        setTotalItem(res.count)
        setData(res.result)

        const toPage = Math.ceil(res.count / limit) || 1
        if (page > toPage) handleParamChange('page', 1)
    }
    const handleSelectPage = (p) => () => {
        if (p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }
    function handleParamChange(key, val) {
        searchParams.delete(key)
        if (val !== '') searchParams.set(key, val)
        setSearchParams(searchParams)
    }
    function selectFilter(item, index) {
        searchParams.delete('type')
        searchParams.set('type', item)
        setSearchParams(searchParams)
    }
    const [isDeleteing, setIsdeleting] = useState(false)
    async function handleConfirmDelete() {
        if (!isDeleteing || !isDeleteing._id) return
        let result = await deleteNotificationById(props.token.token, isDeleteing._id)
        if (result.errno) {
            alert(result.message || '刪除失敗')
            return
        }
        setIsdeleting(false)
        fetchData()
    }

    // const [newNotification, setNewNotification] = useState(false)
    // async function confirmNewNotification() {
    //     if(newNotification?.body?.trim().length<1){
    //         alert('請輸入通知內容')
    //         return
    //     }
    //     let result = await sendPushNotification(props.token.token, {},{type:'none'},newNotification.body)
    //     if (result.errno) {
    //         alert(JSON.stringify(result.message || '發送失敗'))
    //         return
    //     }
    //     alert('通知已發送')
    //     setNewNotification(false)
    //     fetchData()
    // }

    return (
        <div className="relative h-full w-full flex flex-col items-start justify-start bg-[#ddd]" style={{ overflowY: 'auto' }}>
            {/* <div className="flex flex-row w-full px-[16px] justify-between items-center" style={{ }}>
                <div className="text-[10px]"></div>
                <button className="cursor-pointer px-[16px] py-[8px] rounded-[8px] bg-[#0F737E] text-white font-[700]" onClick={()=>{setNewNotification({})}}>
                    + 向所有設備發送新通知
                </button>
            </div> */}
            <div className='w-full flex flex-row items-start justify-start font-bold' style={{ padding: 16, gap: 8, borderBottom: '3px solid #ccc' }}>
                <div className="flex-[1] text-bold text-[14px] text-[#6E604C]">訊息標題</div>
                <div className="flex-1 text-bold text-[14px] text-[#6E604C]">訊息內容</div>
                <div className="flex-1 text-bold text-[14px] text-[#6E604C]">訊息圖片</div>
                <div className="flex-1 text-bold text-[14px] text-[#6E604C]">使用者ID</div>
                <div className="flex-1 text-bold text-[14px] text-[#6E604C]">狀態</div>
                <div className="flex-1 text-bold text-[14px] text-[#6E604C]">通知類型</div>
                <div className="flex-1 text-bold text-[14px] text-[#6E604C]">日期</div>
                <div className="w-[100px]"></div>
            </div>
            {data?.length === 0 && <div className='w-full flex flex-col items-center justify-center' style={{ padding: 16 }}>
                <div className='text-[16px] text-[#6E604C]'>沒有任何交易記錄</div>
            </div>}

            {data?.map((item, index) => {
                return (
                    <div key={index} className='w-full flex flex-row items-start justify-start' style={{ padding: 16, gap: 8, borderBottom: '1px solid #ccc' }}>
                        <div className='flex-[1] text-[14px] text-[#6E604C]' style={{}}>{item?.notification?.title||''}</div>
                        <div className='flex-1 text-[14px] text-[#6E604C]' style={{}}>{item?.notification?.message||''}</div>
                        <div className='flex-1 text-[14px] text-[#6E604C]' style={{}}>{item?.notification?.image?<img src={item.notification.image} style={{width:50,height:50,objectFit:'cover',borderRadius:8}}/>:'無圖片'}</div>
                        <div className='flex-1 text-[14px] text-[#6E604C]'>{item?.userId||'無'}</div>
                        <div className='flex-1 text-[14px] text-[#6E604C]'>{item.status==='READ'? '已讀':item.status==='UNREAD'?'未讀':item.status}</div>
                        <div className='flex-1 text-[14px] text-[#6E604C]'>{item?.type||'無類型'}</div>
                        <div className='flex-1 text-[14px] text-[#6E604C]'>日期: {new Date(item.createDate).toLocaleString()}</div>
                        <div className="w-[100px]">
                            <button onClick={()=>{setIsdeleting(item)}}><Bin/></button>
                        </div>
                    </div>
                )
            }
            )}

            <PageSelector page={page} total={totalItem} totalPage={totalPage} handleSelectPage={handleSelectPage} />

            {isDeleteing && <div className='fixed w-full h-full inset-0 bg-[#00000090] flex items-center justify-center z-[10]'>
                <div className='bg-white rounded-[8px] p-[16px] flex flex-col items-center justify-center' style={{ minWidth: 300 }}>
                    <div className='text-[20px] font-bold text-[#6E604C]'>確認刪除</div>
                    <div className="text-[12px] text-[#6E604C] mt-[8px]">注意：此刪除操作僅會刪除我們資料庫中的記錄。它不會取消/刪除設備上的通知</div>
                    <div className='text-[14px] text-[#6E604C] mt-[8px]'>確定刪除此通知？</div>
                    <div className='flex flex-row items-center justify-center mt-[16px]' style={{ gap: 16 }}>
                        <div onClick={() => { setIsdeleting(false) }} className='cursor-pointer px-[16px] py-[8px] rounded-[8px] bg-[#ccc] text-white'>取消</div>
                        <div onClick={handleConfirmDelete} className='cursor-pointer px-[16px] py-[8px] rounded-[8px] bg-[#e74c3c] text-white'>刪除</div>
                    </div>
                </div>
            </div>}
            {/* {newNotification && <div className='fixed w-full h-full inset-0 bg-[#00000090] flex items-center justify-center z-[10]'>
                <div className='bg-white rounded-[8px] p-[16px] flex flex-col items-center justify-center' style={{ minWidth: 300 }}>
                    <div className='text-[20px] font-bold text-[#6E604C]'>發送新通知</div>
                    <div className="text-[12px] text-[#6E604C] mt-[8px]">注意：此通知將會發送到所有使用者的設備上</div>
                    <textarea value={newNotification?.body||''} onChange={(e)=>{
                        setNewNotification({...newNotification,body:e.target.value})
                    }} placeholder="請輸入通知內容" className="w-full mt-[8px]" style={{minHeight:100,border:'1px solid #ccc',borderRadius:8,padding:8}}/>
                    <div className='flex flex-row items-center justify-center mt-[16px]' style={{ gap: 16 }}>
                        <div onClick={() => { setNewNotification(false) }} className='cursor-pointer px-[16px] py-[8px] rounded-[8px] bg-[#ccc] text-white'>取消</div>
                        <div onClick={confirmNewNotification} className='cursor-pointer px-[16px] py-[8px] rounded-[8px] bg-[#0F737E] text-white'>發送通知</div>
                    </div>
                </div>
            </div>} */}



            {isloading && <LoadingPage />}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)
